import { render, staticRenderFns } from "./resource_center.vue?vue&type=template&id=43954d56&scoped=true"
import script from "./resource_center.vue?vue&type=script&lang=js"
export * from "./resource_center.vue?vue&type=script&lang=js"
import style0 from "./resource_center.vue?vue&type=style&index=0&id=43954d56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43954d56",
  null
  
)

export default component.exports